import { commonFilter } from './filter';

export default {
  pageName: 'BrandCreatorList',
  pageId: '20116',
  pagePath: '/opinion/Influencer/BrandCreatorList',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    IBT_TAB1: {
      buttonId: '2011601',
    },
    IBT_TAB2: {
      buttonId: '2011602',
    },
    ...commonFilter,
  },
};
